import { render, staticRenderFns } from "./Shape.vue?vue&type=template&id=d87376de&scoped=true"
import script from "./Shape.vue?vue&type=script&lang=js"
export * from "./Shape.vue?vue&type=script&lang=js"
import style0 from "./Shape.vue?vue&type=style&index=0&id=d87376de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87376de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d87376de')) {
      api.createRecord('d87376de', component.options)
    } else {
      api.reload('d87376de', component.options)
    }
    module.hot.accept("./Shape.vue?vue&type=template&id=d87376de&scoped=true", function () {
      api.rerender('d87376de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/Shape.vue"
export default component.exports